export function initialize(application) {
  // TODO: Investigar por qué esto ya no funciona en Ember 5.12
  // Referencias:
  //  * https://guides.emberjs.com/v5.12.0/applications/initializers/
  //  * https://github.com/emberjs/ember.js/issues/19505
  // application.inject('route', 'currentUser', 'service:current-user');
  // application.inject('controller', 'currentUser', 'service:current-user');
  // application.inject('component', 'currentUser', 'service:current-user');
}

export default {
  initialize,
};
